module.exports = __webpack_public_path__ + "img/be.37fc0c68.svg";